/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_TotalInputs */

const vi_report_debt_total = /** @type {(inputs: Report_Debt_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng nợ`)
};

/**

* @param {Report_Debt_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_total = /** @type {((inputs?: Report_Debt_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_total(inputs)
});